export type ImageVariant =
  | "athlete"
  | "school"
  | "team"
  | "sport"
  | "news"
  | "merchandise"
  | "user"
  | "generic";

type FallbackAppearance = {
  accent: string;
  accentSoft: string;
  label: string;
};

const variantAppearance: Record<ImageVariant, FallbackAppearance> = {
  athlete: {
    accent: "#d3a63c",
    accentSoft: "#f6e5b9",
    label: "Athlete portrait unavailable",
  },
  school: {
    accent: "#8a6321",
    accentSoft: "#f0dfc1",
    label: "School image unavailable",
  },
  team: {
    accent: "#b2873c",
    accentSoft: "#f2e5cb",
    label: "Team image unavailable",
  },
  sport: {
    accent: "#c88d2b",
    accentSoft: "#f7ead0",
    label: "Sport image unavailable",
  },
  news: {
    accent: "#9a6411",
    accentSoft: "#f6e6cb",
    label: "Story image unavailable",
  },
  merchandise: {
    accent: "#b45309",
    accentSoft: "#fde8cc",
    label: "Product image unavailable",
  },
  user: {
    accent: "#9f3a4e",
    accentSoft: "#f5d6dd",
    label: "Profile image unavailable",
  },
  generic: {
    accent: "#87745a",
    accentSoft: "#eee5d6",
    label: "Image unavailable",
  },
};

const sanitizeLabel = (label?: string | null) =>
  String(label || "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 42);

export const getFallbackAppearance = (variant: ImageVariant = "generic") =>
  variantAppearance[variant];

export const getFallbackLabel = ({
  label,
  variant = "generic",
}: {
  label?: string | null;
  variant?: ImageVariant;
}) => sanitizeLabel(label) || variantAppearance[variant].label;
